import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import CTASection from "@/components/CTASection";
import { Reveal } from "@/components/Reveal";
import { IMG, CUSTOMERS } from "@/data/content";

const Customers = () => (
  <main data-testid="customers-page">
    <PageHero
      eyebrow="Our Customers"
      title="Trusted Hospitality"
      italic="Textile Supplier"
      description="We are delighted to serve and supply hospitality products to reputed names across the industry."
      image={IMG.lobby}
    />

    <section className="py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 border-t border-l border-navy/10">
          {CUSTOMERS.map((name, i) => (
            <Reveal key={name} delay={i * 0.05}>
              <div
                data-testid={`customer-tile-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group flex items-center justify-center h-36 md:h-48 border-r border-b border-navy/10 px-6 text-center transition-colors duration-500 hover:bg-navy"
              >
                <span className="font-serif text-2xl md:text-3xl font-medium text-navy/80 group-hover:text-ivory transition-colors duration-500">
                  {name}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2} className="text-center mt-14">
          <p className="text-navy/70 text-base md:text-lg font-light max-w-2xl mx-auto leading-relaxed">
            We are proud to support leading hospitality businesses with quality bedding, bath textiles and hospitality essentials — along with other reputed hospitality customers across the industry.
          </p>
          <div className="mt-12">
            <p className="font-serif italic text-2xl text-navy">Want to Work With Us?</p>
            <Link
              to="/quote"
              data-testid="customers-request-quote-button"
              className="group inline-flex items-center gap-2 mt-6 bg-navy text-ivory text-[13px] tracking-[0.12em] uppercase px-8 py-4 transition-colors duration-300 hover:bg-gold hover:text-navy"
            >
              Request a Quote
              <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>

    <CTASection
      title="Let's Build Better Hospitality Experiences Together."
      text="Connect with Amazing Grace for quality hospitality textiles and hotel essentials."
      image={IMG.hotelRoom2}
    />
  </main>
);

export default Customers;
